<template>
  <el-dropdown trigger="click" class="international" @command="handleSetTem">
    <div class="temChangeIcon" :title="$t('titles.temChange')">
      
      <span v-if="temType == 'hsd'">℉</span>
      <span v-else>℃</span>
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item :disabled="temType==='ssd'" command="ssd">
        ℃
      </el-dropdown-item>
      <el-dropdown-item :disabled="temType==='hsd'" command="hsd">
        ℉
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['temType'])
  },
  mounted() {
  },
  methods: {
    handleSetTem(temType) {
      console.log(temType)
      if (!temType) {
        temType = 'ssd'
      }
      this.$store.dispatch('setTemType', temType)
    }
  }
}
</script>
<style lang="scss" scoped>
.temChangeIcon{
  width:15px;
  margin-top: 2px;
  img{
    width: 100%;
  }
}
</style>
